export default "__VITE_ASSET__iwuLy4aF__";